import { normalize } from 'normalizr';

import fetchService from 'common/actions/fetchService';
import updateEntities from 'common/actions/updateEntities';
import busBookingInventorySchema from 'modules/bus/booking/shared/schemas/busBookingInventorySchema';
import searchSpec from 'modules/bus/booking/shared/selectors/searchSpecSelector';

export const BUS_BOOKING_FETCH_SEARCH_RESULT =
  'BUS_BOOKING_FETCH_SEARCH_RESULT';

export default function fetchSearchResult(goshow) {
  return (dispatch, getState) =>
    dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetagent/search/inventory',
          searchSpec(getState(), goshow)
        )
      )
    ).then(({ result }) => {
      const { entities, result: idList } = normalize(result.data.inventories, [
        busBookingInventorySchema,
      ]);

      dispatch(updateEntities(entities));

      dispatch({
        type: BUS_BOOKING_FETCH_SEARCH_RESULT,
        payload: { ...result.data, inventories: idList, goshow },
      });

      return result.data;
    });
}
